export const KeyCloakConstants = {
  Email: 'Email',
  UPDATE_PASSWORD: 'UPDATE_PASSWORD',
};
